/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funke_Tv_Digital_Meta_TitleInputs */

const de_funke_tv_digital_meta_title = /** @type {(inputs: Funke_Tv_Digital_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichern Sie sich 10 kostenlose Ausgaben der TV Digital XXL`)
};

/** @type {(inputs: Funke_Tv_Digital_Meta_TitleInputs) => LocalizedString} */
const en_funke_tv_digital_meta_title = de_funke_tv_digital_meta_title;

/**

* @param {Funke_Tv_Digital_Meta_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const funke_tv_digital_meta_title = /** @type {((inputs?: Funke_Tv_Digital_Meta_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funke_Tv_Digital_Meta_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_funke_tv_digital_meta_title(inputs)
	return en_funke_tv_digital_meta_title(inputs)
});